module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/figure/icon_b4a3294df8453d62cfa47831c7c13fe3.png";